import React, { useCallback, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { adminService } from '../../api';
import './AdminCommentsPage.css';

const AdminCommentsPage = () => {
    const [items, setItems] = useState([]);
    const [totalPages, setTotalPages] = useState(1);
    const [page, setPage] = useState(1);
    const [search, setSearch] = useState('');
    const [searchInput, setSearchInput] = useState('');
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [busyId, setBusyId] = useState(null);

    const load = useCallback(() => {
        setLoading(true);
        setError(null);
        adminService.getComments({ page, pageSize: 20, search: search || undefined })
            .then(({ data }) => {
                setItems(data.items);
                setTotalPages(data.totalPages);
            })
            .catch(() => setError('Не удалось загрузить комментарии.'))
            .finally(() => setLoading(false));
    }, [page, search]);

    useEffect(() => { load(); }, [load]);

    const submitSearch = (e) => {
        e.preventDefault();
        setPage(1);
        setSearch(searchInput.trim());
    };

    const remove = async (id) => {
        if (!window.confirm('Удалить комментарий (вместе с ответами на него)?')) return;
        setBusyId(id);
        try {
            await adminService.deleteComment(id);
            setItems(prev => prev.filter(c => c.id !== id));
        } catch {
            alert('Не удалось удалить комментарий.');
        } finally {
            setBusyId(null);
        }
    };

    return (
        <div className="admin-comments">
            <h1 className="admin-comments__title">Комментарии</h1>

            <form className="admin-comments__search" onSubmit={submitSearch}>
                <input
                    className="admin-comments__search-input"
                    placeholder="Поиск по тексту..."
                    value={searchInput}
                    onChange={e => setSearchInput(e.target.value)}
                />
                <button type="submit" className="admin-comments__search-btn">Найти</button>
            </form>

            {loading && <div className="admin-comments__placeholder">Загрузка...</div>}
            {error && <div className="admin-comments__placeholder">{error}</div>}
            {!loading && !error && items.length === 0 && (
                <div className="admin-comments__placeholder">Комментариев не найдено.</div>
            )}

            <div className="admin-comments__list">
                {items.map(c => (
                    <div key={c.id} className="admin-comments__card">
                        <div className="admin-comments__card-main">
                            <div className="admin-comments__meta">
                                <Link to={`/admin/users/${c.authorId}`} className="admin-comments__link">
                                    {c.authorName || c.authorId}
                                </Link>
                                {' → '}
                                <Link to={`/ad/${c.adId}`} target="_blank" className="admin-comments__link">
                                    {c.adTitle || 'объявление удалено'}
                                </Link>
                                {c.parentCommentId && <span className="admin-comments__reply-tag"> · ответ</span>}
                            </div>
                            <div className="admin-comments__content">{c.content}</div>
                            <div className="admin-comments__date">{new Date(c.createdAt).toLocaleString('ru-RU')}</div>
                        </div>
                        <button
                            className="admin-comments__btn-delete"
                            disabled={busyId === c.id}
                            onClick={() => remove(c.id)}
                        >
                            Удалить
                        </button>
                    </div>
                ))}
            </div>

            {totalPages > 1 && (
                <div className="admin-comments__pagination">
                    <button disabled={page <= 1} onClick={() => setPage(p => p - 1)}>Назад</button>
                    <span>{page} / {totalPages}</span>
                    <button disabled={page >= totalPages} onClick={() => setPage(p => p + 1)}>Далее</button>
                </div>
            )}
        </div>
    );
};

export default AdminCommentsPage;
